import { apiService } from '@/services/APIService';

export default {
  // {
  //   "username": "em2",
  //   "password": "password",
  //   "password_confirmation": "password",
  //   "profile": {
  //     "email": "pavel@ttt.ru",
  //     "last_name": "Petrov",
  //     "middle_name": "Petrovich",
  //     "first_name": "Petya",
  //     "region_id": 3,
  //     "municipality_id": 5,
  //     "caption": "YAYAYA",
  //     "birthday_at": null,
  //     "phone": null,
  //   },
  // }
  createEventManager(params) {
    return apiService.post('/user/create-event-manager', params);
  },
  getEventManager(id, params) {
    return apiService.get(`/event-managers/${id}`, params);
  },
  getEventManagers(params) {
    return apiService.get('/event-managers', params);
  },
  getEventManagersRequests(params) {
    return apiService.get('/event-manager-requests/org-requests', params);
  },

  // { organizer_id }
  setActiveOrganizer(params) {
    return apiService.post('event-manager-requests/set-active', params);
  },

  // expand: 'event,event_manager,organizer,event_nomination',
  getPermissions(params) {
    return apiService.get('/event-managers/permissions', params);
  },

  // { event_manager_id, permissions: [] }
  setPermissions(params) {
    return apiService.put('/event-managers/permissions', params);
  },

  updateEventManager(id, params) {
    return apiService.put(`/user/update-event-manager/${id}`, params);
  },
};
